module.exports = __webpack_public_path__ + "static/sphere_logo_mobile-cdce301c483d50e184861f69d2b4b0d8.png";